
import {
  ElRow,
  ElCol,
  ElTag,
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElDialog,
  ElMessage,
  ElDivider,
  ElMessageBox,
} from 'element-plus'
import { defineComponent, onMounted, reactive, ref, toRefs, watch, computed } from 'vue'
import api from '@/services'
import vuex from '@/store'
import { encode } from 'js-base64'
import { ElFormType } from '@/Types/ElementTypes'
import { $t as lang} from '@/Tool'
import { loginOut } from '@/Tool/LoginSet'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  components: {
    ElRow,
    ElCol,
    ElTag,
    ElButton,
    ElForm,
    ElFormItem,
    ElInput,
    ElDialog,
    ElMessage,
    ElDivider,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const detectStatus = computed(() => vuex.state.detectStatus)
    const detectDeadline = computed(() => vuex.state.detectDeadline)

    onMounted(() => {
      queryTimeBalance()
      initDrawTimes()
      if (route?.fullPath.includes('wechat_redirect')) {
        // 微信登录
        const code = useRoute()?.query?.code as string
        if (code) {
          handleWechatBinding(code)
        }
      }
      queryDetectStatus()
    })
    const userInfo = ref<any>({})
    watch(
      () => vuex.state.user && vuex.state.user.info,
      (value) => (userInfo.value = value),
      {
        deep: true,
        immediate: true,
      },
    )
    const Data = reactive({
      visibleDuration: false,
      totalDuration: 0,
      aiDrawTimes: 0,
      accountBalance: 0,
      publicDuration: 0,
      privateDuration: 0,
      dialogTitle: lang('mainMenu.basicInfo.dialogSetup'),
      dialogVisible: false,
      setPwdForm: {
        pwd: '',
        confirmPwd: '',
      },
      resetPwdForm: {
        pwd: '',
        newPwd: '',
        confirmPwd: '',
      },
    })
    const resetForm = ref<string | ElFormType>('resetForm')
    const setForm = ref<string | ElFormType>('setForm')
    const rules = {
      pwd: [
        {
          required: true,
          trigger: 'blur',
          message: lang('uc.accountEdit.rules.password.required'),
        },
        {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&.,:;'])[A-Za-z\d$@$!%*#?&.,:;']{8,}$/,
          message: lang('mainMenu.basicInfo.passwordTip'),
        },
      ],
      newPwd: [
        {
          required: true,
          trigger: 'blur',
          message: lang('uc.accountEdit.rules.password.required'),
        },
        {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&.,:;'])[A-Za-z\d$@$!%*#?&.,:;']{8,}$/,
          message: lang('mainMenu.basicInfo.passwordTip'),
        },
      ],
      confirmPwd: [
        {
          required: true,
          trigger: 'blur',
          message: lang('uc.accountEdit.rules.password.required'),
        },
        {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&.,:;'])[A-Za-z\d$@$!%*#?&.,:;']{8,}$/,
          message: lang('mainMenu.basicInfo.passwordTip'),
        },
      ],
    }

    const handleConfirm = () => {
      vuex.commit('set_data', {
        showConfirmDetectModal: true,
        showDetectAccountModal: false,
      })
    }
    const handleUndoDetect = () => {
      vuex.commit('set_data', {
        showDetectAccountModal: true,
      })
    }

    const queryDetectStatus = async () => {
      const { data, success } = await api.Scrm_sys_api.srcmLogin.getUserTypes({})
      if (success) {
        const currentRole = data.find((item) => item.type === userInfo.value.corpId)
        const value = currentRole?.destroyTime?.slice(0, 10) || ''
        vuex.commit('set_data', {
          detectStatus: currentRole?.destroyId > 0 ? 1 : 0,
          detectDeadline: value,
        })
      }
    }

    const handleUndoSuccess = () => {
      vuex.commit('set_data', {
        showConfirmDeleteModal: false,
        showDeleteAccountModal: false,
      })
      queryDetectStatus()
    }

    // 查询剩余时长
    const queryTimeBalance = async () => {
      const result = await api.Biz_api.srcmLogin.queryDurationBalance({
        data: {
          // accountId: userInfo.value.userId,
          // corpIds: [userInfo.value.corpId],
        },
      })
      const {
        success,
        object: [{ privateDuration, duration, universalDuration, balance }],
      } = result
      if (success) {
        Data.totalDuration = duration
        Data.publicDuration = universalDuration
        Data.privateDuration = privateDuration
        Data.accountBalance = balance
      }
    }

    // 查询剩余绘画次数
    const initDrawTimes = async () => {
      const resp = await api.Biz_api.srcmLogin.fetchAiDrawTimes({
        data: {
          productId: '31020',
          productType: 31000,
        },
      })
      if (resp.success) {
        Data.aiDrawTimes = resp.object?.balance || 0
      }
    }

    const setPwd = () => {
      Data.dialogTitle = lang('mainMenu.basicInfo.dialogSetup')
      Data.dialogVisible = true
    }
    const resetFormField = () => {
      if (userInfo.value.hasPasswd) {
        ;(resetForm.value as ElFormType).resetFields()
      } else {
        ;(setForm.value as ElFormType).resetFields()
      }
    }
    const resetPwd = () => {
      Data.dialogTitle = lang('mainMenu.basicInfo.validateModify')
      Data.dialogVisible = true
    }
    // 确认修改密码
    const confirmReset = () => {
      ;(resetForm.value as ElFormType).validate(async (valid: any) => {
        if (valid) {
          if (Data.resetPwdForm.newPwd != Data.resetPwdForm.confirmPwd) {
            ElMessage({
              message: lang('mainMenu.basicInfo.passwordNotSame'),
              type: 'warning',
            })
            return
          }
          const result = await api.Scrm_sys_api.srcmLogin.setPasswd({
            data: {
              oldPasswd: encode(Data.resetPwdForm.pwd),
              passwd: encode(Data.resetPwdForm.newPwd),
            },
          })
          if (result?.code === '0') {
            await ElMessageBox.confirm(
              lang('mainMenu.basicInfo.tip.modifyPasswordSuccess'),
              lang('mainTip.logout.title'),
              {
                confirmButtonText: lang('mainTip.logout.confirm'),
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                type: 'success',
                callback: () => {
                  Data.dialogVisible = false
                  loginOut(vuex.state.user.orgid as number)
                },
              },
            )
          }
        }
      })
    }
    // 确认设置密码
    const confirmSet = () => {
      ;(setForm.value as ElFormType).validate(async (valid: any) => {
        if (valid) {
          if (Data.setPwdForm.pwd != Data.setPwdForm.confirmPwd) {
            ElMessage({
              message: lang(['mainMenu.basicInfo.passwordNotSame']),
              type: 'warning',
            })
            return
          }
          const result = await api.Scrm_sys_api.srcmLogin.setPasswd({
            data: {
              passwd: encode(Data.setPwdForm.pwd),
            },
          })
          if (result?.code === '0') {
            ElMessage({
              message: lang('mainMenu.basicInfo.tip.setPasswordSuccess'),
              type: 'success',
            })
            Data.dialogVisible = false
            userInfo.value.hasPasswd = true
            vuex.commit('set_data', {
              user: userInfo.value,
            })
          }
        }
      })
    }
    const handleDeleteAccount = () => {
      vuex.commit('set_data', {
        showDetectAccountModal: true,
      })
    }
    function addTab(tabItem: any) {
      let event = new CustomEvent('OPEN_TAB', {
        detail: {
          title: tabItem.title,
          url: tabItem.url,
        },
        bubbles: true,
        cancelable: true,
      })
      window.dispatchEvent(event)
    }
    // 充值
    const recharge = () => {
      addTab({
        key: '',
        title: lang('mainMenu.basicInfo.diamondRecharge'),
        url: '/vshow/diamondTopUp',
        parentKey: '',
        child: [],
      })
    }
    // 充值记录
    const goVideoOrder = () => {
      addTab({
        key: '',
        title: lang('mainMenu.myMenu.myOrder'),
        url: '/vshow/videoOrder',
        parentKey: '',
        child: [],
      })
    }

    // 微信解绑
    const handleUnBind = () => {
      ElMessageBox.confirm(lang('account.set.unBind.confirm'), lang('account.set.unBind.account'), {
        confirmButtonText: lang('account.set.unBind'),
        cancelButtonText: lang('account.set.nowUnBind'),
        type: 'warning',
      }).then(() => {
        api.Scrm_sys_api.srcmLogin
          .wxUnbinding({
            headers: {
              token: vuex.state.user.token,
            },
          })
          .then((resp) => {
            if (resp.success && resp.data) {
              vuex.commit('set_data', {
                user: {
                  info: { ...userInfo.value, wxInfo: null },
                },
              })
              ElMessage({
                type: 'success',
                message: lang('account.set.unBind.success'),
              })
            }
          })
      })
    }

    const handleBinding = () => {
      const redirectUri = location.href.split('?')[0]
      location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wx541487ca137d6a91&redirect_uri=${encodeURIComponent(
        redirectUri,
      )}&response_type=code&scope=snsapi_login&state=wechat_redirect`
    }

    const handleWechatBinding = (code: string) => {
      // 微信绑定
      api.Scrm_sys_api.srcmLogin
        .wxBinding(
          {
            headers: {
              token: vuex.state.user.token,
            },
          },
          code,
        )
        .then((resp) => {
          if (resp.success && resp.data) {
            vuex.commit('set_data', {
              user: {
                info: { ...userInfo.value, wxInfo: resp.data },
              },
            })
            ElMessage({
              type: 'success',
              message: lang('account.set.bind.success'),
            })
            router.push(route.path)
          }
        })
    }


    return {
      ...toRefs(Data),
      rules,
      userInfo,
      setPwd,
      resetPwd,
      confirmReset,
      confirmSet,
      resetForm,
      setForm,
      handleUndoSuccess,
      handleDeleteAccount,
      handleConfirm,
      resetFormField,
      handleUndoDetect,
      recharge,
      lang,
      detectStatus,
      detectDeadline,
      goVideoOrder,
      handleUnBind,
      handleBinding,
      handleWechatBinding
    }
  },
})
